/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ProductVersionsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ProductVersionsQuery = {
  readonly __typename: "Query";
  readonly productVersions: {
    readonly __typename: "VersionStatusUpdate";
    readonly id: string;
    readonly appVersion: string;
    readonly clientVersion: string;
    readonly kernelVersion: string;
    readonly sidecarVersion: string;
  };
};

export const ProductVersionsDocument = /*#__PURE__*/ gql`
  query ProductVersions {
    productVersions {
      id
      appVersion
      clientVersion
      kernelVersion
      sidecarVersion
    }
  }
`;

/**
 * __useProductVersionsQuery__
 *
 * To run a query within a React component, call `useProductVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductVersionsQuery,
    ProductVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductVersionsQuery, ProductVersionsQueryVariables>(
    ProductVersionsDocument,
    options,
  );
}
export function useProductVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductVersionsQuery,
    ProductVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProductVersionsQuery,
    ProductVersionsQueryVariables
  >(ProductVersionsDocument, options);
}
export function useProductVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductVersionsQuery,
    ProductVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ProductVersionsQuery,
    ProductVersionsQueryVariables
  >(ProductVersionsDocument, options);
}
export type ProductVersionsQueryHookResult = ReturnType<
  typeof useProductVersionsQuery
>;
export type ProductVersionsLazyQueryHookResult = ReturnType<
  typeof useProductVersionsLazyQuery
>;
export type ProductVersionsSuspenseQueryHookResult = ReturnType<
  typeof useProductVersionsSuspenseQuery
>;
export type ProductVersionsQueryResult = Apollo.QueryResult<
  ProductVersionsQuery,
  ProductVersionsQueryVariables
>;
